"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.teamLeaderboardTeamNameSx = exports.teamLeaderboardTeamCellSx = exports.teamLeaderboardHeaderGridSx = exports.teamLeaderboardGridSx = exports.teamLeaderboardGridColumns = exports.individualLeaderboardPlayerNameSx = exports.individualLeaderboardPlayerCellSx = exports.individualLeaderboardRowWidthSx = exports.individualLeaderboardContentInsetSx = exports.individualLeaderboardHeaderGridSx = exports.individualLeaderboardGridSx = exports.individualLeaderboardHeaderGridColumns = exports.individualLeaderboardGridColumns = void 0;
/** Data rows — tighter Rank/Thru/Score to give Player ~6–8px more width.
 *  Score column: min 3rem, max 4.5rem (50% wider than the default min). */
exports.individualLeaderboardGridColumns = '1.5rem minmax(0, 1fr) 2.15rem minmax(3rem, 4.5rem)';
/** Headers — keep Thru/Score wide enough for labels.
 *  Score column: min 3.125rem, max 4.7rem (~50% wider than the default min). */
exports.individualLeaderboardHeaderGridColumns = '1.75rem minmax(0, 1fr) 2.35rem minmax(3.125rem, 4.7rem)';
const individualLeaderboardGridBaseSx = {
    display: 'grid',
    gap: 0.5,
    alignItems: 'center',
    minWidth: 0,
    width: '100%',
    maxWidth: '100%',
    boxSizing: 'border-box',
};
exports.individualLeaderboardGridSx = {
    ...individualLeaderboardGridBaseSx,
    gridTemplateColumns: exports.individualLeaderboardGridColumns,
};
/** Extra space between Rank and Player column labels only. */
exports.individualLeaderboardHeaderGridSx = {
    ...individualLeaderboardGridBaseSx,
    gridTemplateColumns: exports.individualLeaderboardHeaderGridColumns,
    '& > :nth-of-type(2)': {
        paddingLeft: 2,
    },
    '& > :nth-of-type(3), & > :nth-of-type(4)': {
        whiteSpace: 'nowrap',
    },
};
/** Horizontal gutter shared by accordion details and flat list scroll areas. */
exports.individualLeaderboardContentInsetSx = {
    px: 0.75,
    minWidth: 0,
    boxSizing: 'border-box',
};
/** Row cards and headers fill the inset content area (accordion or flat list). */
exports.individualLeaderboardRowWidthSx = {
    width: '100%',
    maxWidth: '100%',
    minWidth: 0,
    boxSizing: 'border-box',
};
exports.individualLeaderboardPlayerCellSx = {
    minWidth: 0,
    maxWidth: '100%',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
};
exports.individualLeaderboardPlayerNameSx = {
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
};
/** Team rows — wider name column than individual.
 *  Score column: min 3.25rem, max 4.875rem (~50% wider than the default min). */
exports.teamLeaderboardGridColumns = '1.75rem minmax(0, 1fr) 2.15rem minmax(3.25rem, 4.875rem)';
exports.teamLeaderboardGridSx = {
    ...individualLeaderboardGridBaseSx,
    gridTemplateColumns: exports.teamLeaderboardGridColumns,
};
exports.teamLeaderboardHeaderGridSx = {
    ...individualLeaderboardGridBaseSx,
    gridTemplateColumns: exports.teamLeaderboardGridColumns,
    '& > :nth-of-type(3), & > :nth-of-type(4)': {
        whiteSpace: 'nowrap',
    },
};
exports.teamLeaderboardTeamCellSx = {
    minWidth: 0,
    maxWidth: '100%',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
};
exports.teamLeaderboardTeamNameSx = {
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
};
